export class LoadStreamerFollowers {
  static readonly type = "[StreamerFollow] Load Streamer Followers";
  constructor(
    public page?: number,
    public pageSize?: number,
  ) {}
}

export class ReloadStreamerFollowers {
  static readonly type = "[StreamerFollow] Reload Streamer Followers";
  constructor() {}
}

export class ClearStreamerFollowers {
  static readonly type = "[StreamerFollow] Clear Streamer Followers";
  constructor() {}
}
